import React from "react";

import { styled } from "@mui/material/styles";

const SeparatorStyle = styled("p")(({ theme }) => ({
  color: theme.palette.shades.neutral[200],
  display: "grid",
  gridTemplateColumns: "1fr max-content 1fr",
  gridTemplateRows: "20px",
  gridGap: "20px",
  justifyContent: "center",
  alignItems: "center",
  margin: "18px 0",
  width: "100%",
  fontSize: "0.875rem",
  fontWeight: "500",
  "&::after": {
    content: '" "',
    display: "block",
    borderBottom: `2px solid ${theme.palette.shades.neutral[50]}`,
  },
  "&::before": {
    content: '" "',
    display: "block",
    borderBottom: `2px solid ${theme.palette.shades.neutral[50]}`,
  },
}));

const Separator = (props: any) => (
  <SeparatorStyle>{props.children}</SeparatorStyle>
);

export default Separator;
